<script setup lang="ts">
import {
	DropdownMenuItem,
	useForwardPropsEmits,
	type DropdownMenuItemEmits,
	type DropdownMenuItemProps,
} from "reka-ui";
import { RouterLink, type RouterLinkProps } from "vue-router";
import type { ClassProps } from "../../lib/base-props";

defineOptions({ inheritAttrs: false });

interface Props
	extends Omit<DropdownMenuItemProps, "asChild" | "as">,
		ClassProps,
		Omit<RouterLinkProps, "custom"> {}

const props = defineProps<Props>();
const emit = defineEmits<DropdownMenuItemEmits>();

const forwarded = useForwardPropsEmits(props, emit);
</script>

<template>
	<DropdownMenuItem as="li" v-bind="forwarded">
		<RouterLink :class="props.class" v-bind="forwarded">
			<slot />
		</RouterLink>
	</DropdownMenuItem>
</template>
